export default __webpack_public_path__ + "static/media/visible-icon.0fd134f5.svg";